function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-width: 1px;\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M327,318c55.7-.577,191.725-0.982,223,20l20-12,26,39c5.054,17.83-5.389,60.475-10,72-21.25,53.115-51.3,96.922-119,102-1.623-5.252-5.537-26.413-10-30l-20-3-18-11c-23.335-9.068-45.7.509-58,11-19.35-7.664-27.055,10.7-41,17l6,7-7-5c-4.756,2.341-8.988,4.351-14,4-22.713-21.682-52.4-82.019-43-134q7.5-32,15-64l11,2c4.468-1.962,9.038-8.862,15-11Zm252,2c5.087,4.314,8.789,11.97,11,19l-4-3-10-13q0.5-1,1-2ZM178,616h4l-4,2v-2Z"
});

var SvgFHairstyleFrizzyLongBackVector = function SvgFHairstyleFrizzyLongBackVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f_hairstyle_frizzy_long_back_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFHairstyleFrizzyLongBackVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f_hairstyle_frizzy_long_back_vector.ccdaec7b.svg";
export { ForwardRef as ReactComponent };